import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
export const ComparisonTable: React.FC = () => {
  return <section className="py-10 md:py-20 bg-white" data-id="element-49">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-50">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-6 md:mb-12" data-id="element-51">
          <h2 className="text-2xl md:text-4xl font-bold font-serif text-gray-900" data-id="element-52">
            ¿Cuánto cuesta NO tenerlo?
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-xl md:rounded-2xl shadow-xl border border-gray-200 overflow-hidden" data-id="element-53">
          <div className="overflow-x-auto" data-id="element-54">
            <table className="w-full text-left border-collapse min-w-[480px]" data-id="element-55">
              <thead data-id="element-56">
                <tr data-id="element-57">
                  <th className="bg-gray-100 p-3 md:p-6 font-bold text-gray-600 border-b border-gray-200 w-1/2 text-xs md:text-lg text-center" data-id="element-58">
                    SIN PROFES DE TELAS RESUELTO
                  </th>
                  <th className="bg-green-50 p-3 md:p-6 font-bold text-green-800 border-b border-green-200 w-1/2 text-xs md:text-lg text-center" data-id="element-59">
                    CON PROFES DE TELAS RESUELTO
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100" data-id="element-60">
                <tr data-id="element-61">
                  <td className="p-3 md:p-5 text-xs md:text-base text-gray-600 flex items-center gap-2 md:gap-3" data-id="element-62">
                    <span className="text-base md:text-xl" data-id="element-63">⏰</span>
                    3-5 horas/semana planificando desde cero
                  </td>
                  <td className="p-3 md:p-5 text-xs md:text-base text-gray-900 font-medium bg-green-50/30 flex items-center gap-2 md:gap-3" data-id="element-64">
                    <span className="text-base md:text-xl" data-id="element-65">✅</span>
                    10 min/semana. El resto es enseñar.
                  </td>
                </tr>
                <tr data-id="element-66">
                  <td className="p-3 md:p-5 text-xs md:text-base text-gray-600 flex items-center gap-2 md:gap-3" data-id="element-67">
                    <span className="text-base md:text-xl" data-id="element-68">😓</span>
                    Siempre las mismas figuras → las alumnas se aburren
                  </td>
                  <td className="p-3 md:p-5 text-xs md:text-base text-gray-900 font-medium bg-green-50/30 flex items-center gap-2 md:gap-3" data-id="element-69">
                    <span className="text-base md:text-xl" data-id="element-70">✅</span>
                    60+ clases distintas → siempre hay algo nuevo
                  </td>
                </tr>
                <tr data-id="element-71">
                  <td className="p-3 md:p-5 text-xs md:text-base text-gray-600 flex items-center gap-2 md:gap-3" data-id="element-72">
                    <span className="text-base md:text-xl" data-id="element-73">💸</span>
                    Alumnas que abandonan sin saber por qué
                  </td>
                  <td className="p-3 md:p-5 text-xs md:text-base text-gray-900 font-medium bg-green-50/30 flex items-center gap-2 md:gap-3" data-id="element-74">
                    <span className="text-base md:text-xl" data-id="element-75">✅</span>
                    Sistema de progresión → retención visible
                  </td>
                </tr>
                <tr data-id="element-76">
                  <td className="p-3 md:p-5 text-xs md:text-base text-gray-600 flex items-center gap-2 md:gap-3" data-id="element-77">
                    <span className="text-base md:text-xl" data-id="element-78">📋</span>
                    Sin progresión clara de nivel a nivel
                  </td>
                  <td className="p-3 md:p-5 text-xs md:text-base text-gray-900 font-medium bg-green-50/30 flex items-center gap-2 md:gap-3" data-id="element-79">
                    <span className="text-base md:text-xl" data-id="element-80">✅</span>6 tomos con
                    progresión anual → mejoran y se quedan
                  </td>
                </tr>
                <tr data-id="element-81">
                  <td className="p-3 md:p-5 text-xs md:text-base text-gray-600 flex items-center gap-2 md:gap-3" data-id="element-82">
                    <span className="text-base md:text-xl" data-id="element-83">😨</span>
                    Alumna con dificultad = pánico o improvisación
                  </td>
                  <td className="p-3 md:p-5 text-xs md:text-base text-gray-900 font-medium bg-green-50/30 flex items-center gap-2 md:gap-3" data-id="element-84">
                    <span className="text-base md:text-xl" data-id="element-85">✅</span>
                    Protocolo de seguridad → actuás con confianza
                  </td>
                </tr>
                <tr data-id="element-86">
                  <td className="p-3 md:p-5 text-xs md:text-base text-gray-600 flex items-center gap-2 md:gap-3" data-id="element-87">
                    <span className="text-base md:text-xl" data-id="element-88">👥</span>
                    Niveles mezclados = caos de clase
                  </td>
                  <td className="p-3 md:p-5 text-xs md:text-base text-gray-900 font-medium bg-green-50/30 flex items-center gap-2 md:gap-3" data-id="element-89">
                    <span className="text-base md:text-xl" data-id="element-90">✅</span>
                    Variaciones por nivel → todas mejoran juntas
                  </td>
                </tr>
                <tr data-id="element-91">
                  <td className="p-3 md:p-5 text-xs md:text-base text-gray-600 flex items-center gap-2 md:gap-3" data-id="element-92">
                    <span className="text-base md:text-xl" data-id="element-93">📱</span>
                    Sin sistema de comunicación con alumnas
                  </td>
                  <td className="p-3 md:p-5 text-xs md:text-base text-gray-900 font-medium bg-green-50/30 flex items-center gap-2 md:gap-3" data-id="element-94">
                    <span className="text-base md:text-xl" data-id="element-95">✅</span>
                    Guía de marketing + 30 días de contenido planificado
                  </td>
                </tr>
                <tr data-id="element-96">
                  <td className="p-3 md:p-5 text-xs md:text-base text-gray-600 flex items-center gap-2 md:gap-3" data-id="element-97">
                    <span className="text-base md:text-xl" data-id="element-98">💼</span>
                    Sin identidad profesional visible
                  </td>
                  <td className="p-3 md:p-5 text-xs md:text-base text-gray-900 font-medium bg-green-50/30 flex items-center gap-2 md:gap-3" data-id="element-99">
                    <span className="text-base md:text-xl" data-id="element-100">✅</span>
                    Sistema que justifica cobrar lo que merecés
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </motion.div>
      </div>
    </section>;
};